import { ImagePath } from "../../../assets/ImagePath";
import { Input } from "../../../components/ui/input";
import { Button } from "../../../components/ui/button";
import { Label } from "../../../components/ui/label";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { showToast } from "../../../components/ui/toaster";
import { appType } from "../../../utils/config/configHelpers";
import { UserServiceClientApi } from "../../../services/api/UserApiServices";
import LoadingModal from "../../../components/ui/Loader/LoadingModal";
import { passwordErrorMessage, passwordRegex } from "../../../utils/Validator";
import useIsLaptopScreen from "../../../utils/customHooks/useIsLaptopScreen";
import { getDomainConfig } from "../../../utils/DomainsHelper";


const Register = () => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({ emailError: "", passwordError: "", nameError: "", confirmPasswordError: "" });
  const [isFocused, setIsFocused] = useState({ email: false, password: false, name: false, confirmPassword: false });
  const [highlightName, setHighlightName] = useState(false);
  const [highlightPass, setHighlightPass] = useState(false);
  const [highlightEmail, setHighlightEmail] = useState(false);
  const [highlightConfirmPassword, setHighlightConfirmPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [userData, setUserData] = useState({ email: "", password: "", name: "", confirmPassword: "", dialCode: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [logoImage,setLogoImage] = useState('')
  const isLaptopScreen = useIsLaptopScreen();

  const handleChange = (text, field, dialCode) => {
    setUserData((prev) => ({ ...prev, [field]: text.target.value }));
    setErrors((prev) => ({ ...prev, [`${field}Error`]: "" }));
  };



  const handleSubmit = () => {
    let valid = true;
    let tempErrors = { emailError: "", passwordError: "", nameError: "", confirmPasswordError: "" };
    // Name validation
    if (!userData.name.trim()) {
      tempErrors.nameError = "Name is required";
      valid = false;
    }

    // Email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!userData.email.trim()) {
      tempErrors.emailError = "Email is required";
      valid = false;
    } else if (!emailPattern.test(userData.email)) {
      tempErrors.emailError = "Invalid email format";
      valid = false;
    }

    // Phone validation

    if (!userData.password) {
      tempErrors.passwordError = "Password is required";
      valid = false;
    } else if (!passwordRegex.test(userData.password)) {
      tempErrors.passwordError = passwordErrorMessage;
      valid = false;
    }

    // Password validation
    if (!userData.password) {
      tempErrors.passwordError = "Password is required";
      valid = false;
    } else if (userData.password.length < 6) {
      tempErrors.passwordError = "Password must be at least 6 characters";
      valid = false;
    }

    // Confirm Password validation
    if (!userData.confirmPassword) {
      tempErrors.confirmPasswordError = "Confirm Password is required";
      valid = false;
    } else if (userData.confirmPassword !== userData.password) {
      tempErrors.confirmPasswordError = "Passwords do not match";
      valid = false;
    }

    setErrors(tempErrors);
    if (valid) {
      setIsLoading(true);
      // Proceed with form submission (e.g., API call)
      console.log("Form submitted successfully", userData);
      const signupObj = {
        email: userData.email,
        password: userData.password,
        userName: `${userData.name}`,
        appType: appType,
      };
      UserServiceClientApi.signupUser(signupObj).then((res) => {
        setIsLoading(false);
        console.log("res", res);
        if (res.success) {
          showToast('success', "User registered successfully! Please verify your email.");
          navigate("/verify", { state: { ...userData } });
        } else {
          showToast('error', res.message);
        }
      }).catch((err => {
        console.log("err", err);
        setIsLoading(false);
      }))
    }
  };

  useEffect(() => {
    const handleEnterKey = (e) => {
      if (e.key === "Enter") {
        handleSubmit();
      }
    };

    window.addEventListener("keydown", handleEnterKey);
    return () => window.removeEventListener("keydown", handleEnterKey);
  }, [userData]);

  useEffect(() => {
  const config = getDomainConfig();
    setLogoImage(config.logo);
  },[])

  return (
    <>
      <div className="sm:col-span-6 col-span-12 lg:px-[60px] lg:py-[20px] px-[10px] py-[30px] h-full">
        <div className="flex flex-col h-full justify-between max-w-[491px] w-full !mx-auto">
          {logoImage &&
          <img
            className="mx-auto 3xl:w-[210px] lg:w-[180px] w-[140px] lg:mb-[35px]"
            src={logoImage}
            alt="Onship log"
          />}
          <div>
            {!isLaptopScreen && <h1 className="lg:text-size-30 text-size-20 text-black font-semibold text-center lg:mb-[35px] mb-[15px]">
              Create your account
            </h1>}
            <div className="bg-[#F8F8F8] rounded-20 lg:px-[45px] lg:py-[45px] p-[25px] lg:mx-[25px]">
              <div className="space-y-[20px]" >
                <div className="space-y-2 relative">
                  <Label
                    htmlFor="name"
                    labelError={errors.nameError}
                    highlightEmail={highlightName}
                    isFocused={isFocused.name}
                  >
                    Name
                  </Label>
                  <Input
                    type="name"
                    inputError={errors.nameError}
                    placeholder="Please enter your name"
                    onChange={(t) => handleChange(t, "name")}
                    value={userData.name}
                    highlightEmail={highlightName}
                    onFocus={() => {
                      setHighlightName(false);
                      setIsFocused({ name: true })
                    }}
                    onBlur={() => setIsFocused({ name: false })}

                  />
                  {errors.nameError && (
                    <p className="text-red text-size-10 font-regular">
                      {errors.nameError}
                    </p>
                  )}
                </div>
                <div className="space-y-2 relative">
                  <Label
                    htmlFor="email"
                    labelError={errors.emailError}
                    highlightEmail={highlightEmail}
                    isFocused={isFocused.email}
                  >
                    Email
                  </Label>
                  <Input
                    type="email"
                    inputError={errors.emailError}
                    placeholder="Please enter your email"
                    onChange={(t) => handleChange(t, "email")}
                    value={userData.email}
                    highlightEmail={highlightEmail}
                    onFocus={() => {
                      setHighlightEmail(false);
                      setIsFocused({ email: true })
                    }}
                    onBlur={() => setIsFocused({ email: false })}
                  />
                  {errors.emailError && (
                    <p className="text-red text-size-10 font-regular">
                      {errors.emailError}
                    </p>
                  )}
                </div>
                <div className="space-y-2 relative">
                  <Label
                    htmlFor="password"
                    labelError={errors.passwordError}
                    isFocused={isFocused.password}
                    highlightEmail={highlightPass}
                  >
                    Password
                  </Label>
                  <Input
                    type={showPassword ? "text" : "password"}
                    placeholder="Please enter your password"
                    inputError={errors.passwordError}
                    showPassword={showPassword}
                    setShowPassword={setShowPassword}
                    onChange={(t) => handleChange(t, "password")}
                    value={userData.password}
                    onBlur={() => setIsFocused({ password: false })}
                    onFocus={() => {
                      setIsFocused({ password: true })
                    }}
                  />
                  {errors.passwordError && (
                    <p className="text-red text-size-10 font-regular">
                      {errors.passwordError}.
                    </p>
                  )}
                </div>
                <div className="space-y-2 relative">
                  <Label
                    htmlFor="confirmPassword"
                    labelError={errors.confirmPasswordError}
                    isFocused={isFocused.confirmPassword}
                    highlightEmail={highlightConfirmPassword}
                  >
                    Confirm Password
                  </Label>
                  <Input
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Please enter your confirm password"
                    inputError={errors.confirmPasswordError}
                    showPassword={showConfirmPassword}
                    setShowPassword={setShowConfirmPassword}
                    onChange={(t) => handleChange(t, "confirmPassword")}
                    value={userData.confirmPassword}
                    onBlur={() => setIsFocused({ confirmPassword: false })}
                    onFocus={() => {
                      setIsFocused({ confirmPassword: true })
                    }}
                  />
                  {errors.confirmPasswordError && (
                    <p className="text-red text-size-10 font-regular">
                      {errors.confirmPasswordError}.
                    </p>
                  )}
                </div>
                <Button className="text-white" onClick={handleSubmit}>
                  Create account
                </Button>
                <p className="text-gray-300 text-size-14 font-regular text-center">
                  Already have an Account?{" "}
                  <Link
                    to={'/'}
                    className="text-blue text-size-14 font-medium cursor-pointer"
                  >
                    Log In
                  </Link>
                </p>
              </div>
            </div>
          </div>
          <img
            className="mx-auto w-full max-w-[260px] 3xl:mt-[80px] lg:w-[231px] mt-[30px] mb-6px"
            src={ImagePath.poweredText}
            alt="Onship || Images(svg, jpg, png"
          />
        </div>
      </div>
      {isLoading && <LoadingModal />}
    </>
  );
};

export default Register;
